const ReactAppsRegistry = [
    'render-app-registry',
    'render-app-navigation-header',
]

export default ReactAppsRegistry;